<h4 class="self-center text-h4 font-medium text-text-secondary">{{ 'collab_message_unsend_dialog_title' | translate }}</h4>
<h5 class="self-center text-center text-h5 font-normal text-text-secondary">
  {{ 'collab_message_unsend_dialog_description' | translate }}
</h5>

<div class="mt-4 flex grow justify-center gap-4">
  <button class="btn-secondary w-full justify-center" (click)="closeDialog(false)">
    {{ 'collab_message_unsend_dialog_cancel' | translate }}
  </button>
  <button
    class="btn-warn w-full justify-center"
    (click)="closeDialog(true)"
    [ffdPushTagOnClick]="{
      event: TagEvent.CollaborationMessageUnsent
    }"
  >
    {{ 'collab_message_unsend' | translate }}
  </button>
</div>
